"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const insuranceCoverage_1 = require("../../../insuranceCoverage");
const policy_1 = require("../../policy");
const uuid_1 = require("uuid");
const broker_1 = __importDefault(require("../../broker"));
const formatISO_1 = __importDefault(require("date-fns/formatISO"));
class BasePolicyRequest {
    constructor(data) {
        this.policyNumber = data.policyNumber;
        this.type = data.type;
        this.region = data.region;
        this.user = data.user;
        this.partnerId = data.partnerId;
        this.broker = data.broker;
        this.status = data.status;
        this.createdDate = data.createdDate;
        this.effectiveDate = data.effectiveDate;
        this.channel = data.channel;
        this.callback = data.callback;
    }
    static fromObj(data) {
        const broker = broker_1.default.fromObj(data.broker);
        const callback = (data === null || data === void 0 ? void 0 : data.callback)
            ? insuranceCoverage_1.Callback.fromObj(data.callback)
            : undefined;
        const { partner } = data;
        return new BasePolicyRequest({
            policyNumber: data.policyNumber,
            type: data.type,
            region: data.region,
            user: data.user,
            partnerId: partner.id,
            broker,
            status: data.status,
            channel: data.channel,
            effectiveDate: data.effectiveDate,
            createdDate: data.createdDate,
            callback
        });
    }
    static create(data) {
        const policyNumber = uuid_1.v4().toUpperCase();
        const status = policy_1.ePolicyStatus.DRAFT;
        const createdDate = new Date();
        return new BasePolicyRequest({
            policyNumber,
            type: data.type,
            region: data.region,
            user: data.user,
            partnerId: data.partnerId,
            broker: data.broker,
            status,
            channel: data.channel,
            effectiveDate: data.effectiveDate,
            createdDate: formatISO_1.default(createdDate),
            callback: data.callback
        });
    }
}
exports.default = BasePolicyRequest;
//# sourceMappingURL=basePolicyRequest.class.js.map